@if (userLoggedIn$ | async) {
  @if (wishListEntries$ | async; as entries) {
    @if ((product$ | async) || product; as product) {
      @if (isInStock(product)) {
        <ng-container [ngTemplateOutlet]="(checkboxStyle === 'true') ? checkboxStyleTemplate : btnStyletemplate"
        [ngTemplateOutletContext]="{ product: product, entries: entries}"></ng-container>
      }
    }
  }
} @else {
  @if (hasStock) {
    <a class="btn btn-primary button-add-link" [routerLink]="{ cxRoute: 'login' } | cxUrl">
      <cx-icon [type]="iconTypes.EMPTY_HEART"></cx-icon><span class="button-text">
    {{ 'addToWishList.anonymous' | cxTranslate }}</span>
  </a>
}
}


<ng-template #checkboxStyleTemplate let-product='product' let-entries='entries'>
  <div class="add-to-wishlist__container form-check">
    @if (getProductInWishList(product, entries); as entry) {
      <input class="form-check-input" type="checkbox" name="wishlist" id="wishlist_{{ product.code }}"
        (change)="toggleProductInWishlist($event, entry, product)" [checked]="true" />
      } @else {
        <input class="form-check-input" type="checkbox" name="wishlist" id="wishlist_{{ product.code }}"
          (change)="toggleProductInWishlist($event, entry, product)" />
        }
        <label class="form-check-label" for="wishlist_{{ product.code }}">
          {{ 'product.wishlist' | cxTranslate }}
        </label>
      </div>
    </ng-template>

    <ng-template #btnStyletemplate let-product='product' let-entries='entries'>
      @if (getProductInWishList(product, entries); as entry) {
        <div>
          <button class="btn btn-primary button-remove" (click)="remove(entry)" [disabled]="loading$ | async" id="wishlist_heart_{{ product.code }}">
            <cx-icon [type]="iconTypes.HEART"></cx-icon>
            <span class="button-text">{{ 'addToWishList.remove' | cxTranslate }}</span>
          </button>
        </div>
      } @else {
        <button class="btn btn-primary button-add" (click)="add(product)" [disabled]="loading$ | async" id="wishlist_heart_{{ product.code }}">
          <cx-icon [type]="iconTypes.EMPTY_HEART"></cx-icon>
          <span class="button-text"> {{ 'addToWishList.add' | cxTranslate }}</span>
        </button>
      }
    </ng-template>
